import BulkAddUsersPage from './BulkAddUsersPage';

export default BulkAddUsersPage;
